<template>
	<div class="sync-backdrop">
		<div class="sync-container">
			<img
				src="@static/img/cdkPush.svg"
				v-if="CDKPushing"
			/>
			<img
				src="@static/img/cdkConnecting.svg"
				v-else
			/>
			<div
				class="img-caption"
				v-if="CDKPushing"
			>
				We are saving this Deal Information into CDK <br />Please wait until the process is complete.
			</div>
			<div
				class="img-caption"
				v-else
			>
				Establishing Connection with CDK <br />Please wait until the process is complete.
			</div>
		</div>
	</div>
</template>
<script lang="ts">
	export interface ICDKPushProps {
		data?: any;
		postFunction?: any;
		CDKPushing?: boolean;
	}
</script>
<script setup lang="ts">
	import api from '@core/services/api/_api';
	import { useVuelidate } from '@vuelidate/core';
	import { computed, inject, ref, watch } from 'vue';
	import { Emitter } from 'mitt';

	const { CDKPushing, data, postFunction } = defineProps<ICDKPushProps>();
	const EventBus = inject<Emitter<any>>('EventBus', null);

	const infoToShow = ref<any>(null);
	const noResponse = computed(() => {
		return infoToShow.value.syncOperations ? infoToShow.value.syncOperations.length > 0 : false;
	});

	watch(
		() => CDKPushing,
		newValue => {
			if (newValue) {
				cdkSync();
			} else {
				EventBus.emit('CDKPushFinish');
				postFunction({});
			}
		},
	);

	function cdkSync() {
		api.dart
			.sync(data)
			.then(response => {
				if (response && response.data) {
					//TODO show all responses
					EventBus.emit('CDKPushFinish');
					postFunction(response.data);
				}
			})
			.catch(err => {
				console.error(err);
			});
	}
</script>
<style></style>
